export class Region {
    id: string;
    code: string;
    name: string;
    fromDate: string;
    toDate: string;
    idNation: number;
  }
  